import { get } from 'lodash';

export const getLoadingCompleted = (state) => get(state, ['loadingProgress', 'completed'], 0);
export const getLoadingTotal = (state) => get(state, ['loadingProgress', 'total'], 0);
export const getLoadingLastLabel = (state) => get(state, ['loadingProgress', 'lastLabel'], '');
